// ニュース記事。1記事に全言語をまとめて持たせ、追加時に1箇所だけ見ればよい形にする。
// date は ISO 8601。表示は formatNewsDate() が言語別に整形する。
export const newsData = [
  {
    id: 1,
    date: '2025-11-26',
    category: {
      ja: 'お知らせ',
      en: 'News',
      'zh-CN': '通知',
      'zh-TW': '通知',
    },
    title: {
      ja: 'ウェブサイトをリニューアルいたしました',
      en: 'Our Website Has Been Renewed',
      'zh-CN': '本公司网站已改版上线',
      'zh-TW': '本公司網站已改版上線',
    },
    content: {
      ja: `
      ウェブサイトのリニューアルを完了しました。今後ともよろしくお願いいたします。
    `,
      en: `
      We have completed the renewal of our website. We look forward to your continued support.
    `,
      'zh-CN': `
      本公司网站的改版工作已经完成。今后也请多多关照。
    `,
      'zh-TW': `
      本公司網站的改版工作已經完成。今後也請多多指教。
    `,
    },
  },
  {
    id: 2,
    date: '2025-11-26',
    category: {
      ja: '広告',
      en: 'Advertisement',
      'zh-CN': '广告',
      'zh-TW': '廣告',
    },
    title: {
      ja: '兵庫県三田市「三田陶芸の森。」特別日帰りツアーのご案内',
      en: 'Special Day Tour at Sanda Ceramic Forest, Sanda City, Hyogo',
      'zh-CN': '兵库县三田市「三田陶艺之森。」特别一日游介绍',
      'zh-TW': '兵庫縣三田市「三田陶藝之森。」特別一日遊介紹',
    },
    content: {
      ja: `
      兵庫県三田市にある「三田陶芸の森。」が特別日帰りツアーを企画。
      世界三大青磁の一つと称される「三田青磁」。
      通常非公開の製造工程の見学や加飾、窯入れ体験。
      三田の食材とお茶をテーマにした特別料理。本格茶道体験。

      ■行程（Itinerary）

      10:00–11:30｜陶芸体験
      三田陶芸の森にて、伊藤館長（Zuihou Ito）指導による三田青磁の陶芸体験。
      通常は非公開の制作工程の見学も含まれます。

      12:00–13:30｜和食ランチ
      地元食材を使った、茶をテーマにした季節の和食コース。
      三田青磁の器で提供されます。
      ※万一ご用意できない場合は、同等内容の食事体験をご案内します。

      14:00–16:00｜茶道体験
      三田青磁の茶道具を使用した、本格的な裏千家茶道体験。
      ※会場の都合により、三田陶芸の森内のプライベート茶室で実施する場合があります。

      ■この体験に含まれるもの

      ・専属ガイド付きのプライベート1日ツアー
      ・三田青磁の陶芸ワークショップ
      ・通常非公開の制作工程への特別アクセス
      ・茶をテーマにした和食ランチコース
      ・裏千家による茶道体験
      ・三田青磁の茶器セット（お土産）
      ・制作した作品のご自宅への配送
      （完成後、約1〜2か月でお届け）

      文化的な深み、プライバシーへの配慮、そして無理のないゆったりとした行程を重視した、特別な体験をお求めの方におすすめです。
      本ツアーにご興味がございましたら、リンクより詳細をご確認ください。
    `,
      en: `
      Sanda Ceramic Forest in Sanda City, Hyogo Prefecture, has created a special day tour.
      Sanda celadon is regarded as one of the world's three great celadon traditions.
      The tour includes a look at production stages normally closed to the public, plus decoration and kiln-loading experiences.
      It also features a special meal built around Sanda's ingredients and tea, and an authentic tea ceremony.

      Itinerary

      10:00-11:30 | Pottery experience
      A Sanda celadon pottery session at Sanda Ceramic Forest, guided by director Zuihou Ito.
      It includes a look at production stages that are normally closed to the public.

      12:00-13:30 | Japanese lunch
      A seasonal Japanese course built around tea, made with local ingredients.
      It is served on Sanda celadon ware.
      *Should any dish be unavailable, we will offer a dining experience of equivalent content.

      14:00-16:00 | Tea ceremony experience
      An authentic Urasenke tea ceremony using Sanda celadon tea utensils.
      *Depending on venue availability, it may be held in a private tea room inside Sanda Ceramic Forest.

      What this experience includes

      - A private one-day tour with a dedicated guide
      - A Sanda celadon pottery workshop
      - Special access to production stages normally closed to the public
      - A tea-themed Japanese lunch course
      - A tea ceremony conducted by Urasenke
      - A Sanda celadon tea utensil set (souvenir)
      - Delivery of the piece you make to your home
      (delivered roughly one to two months after completion)

      We recommend it to those seeking a special experience that values cultural depth, privacy, and an unhurried, comfortable pace.
      If you are interested in this tour, please see the link below for details.
    `,
      'zh-CN': `
      位于兵库县三田市的「三田陶艺之森。」推出了特别一日游。
      被誉为世界三大青瓷之一的「三田青瓷」。
      可参观平时不对外公开的制作工序，并体验加饰与入窑。
      以三田当地食材与茶为主题的特别料理，以及正统茶道体验。

      ■行程（Itinerary）

      10:00–11:30｜陶艺体验
      在三田陶艺之森，由伊藤馆长（Zuihou Ito）指导，体验三田青瓷陶艺。
      并包含参观平时不对外公开的制作工序。

      12:00–13:30｜日式午餐
      使用当地食材、以茶为主题的时令日式套餐。
      以三田青瓷器皿盛装呈现。
      ※如遇无法准备的情况，将为您安排同等内容的餐饮体验。

      14:00–16:00｜茶道体验
      使用三田青瓷茶具的正统里千家茶道体验。
      ※视会场情况，可能在三田陶艺之森内的私人茶室举行。

      ■本体验包含的内容

      ・配备专属导游的私人一日游
      ・三田青瓷陶艺工作坊
      ・平时不对外公开的制作工序的特别参观
      ・以茶为主题的日式午餐套餐
      ・由里千家主持的茶道体验
      ・三田青瓷茶具套装（纪念品）
      ・所制作作品的送货到府服务
      （完成后约1～2个月送达）

      推荐给重视文化深度、隐私考量，以及从容不迫行程安排的、追求特别体验的贵宾。
      如对本行程有兴趣，请通过链接查看详情。
    `,
      'zh-TW': `
      位於兵庫縣三田市的「三田陶藝之森。」推出了特別一日遊。
      被譽為世界三大青瓷之一的「三田青瓷」。
      可參觀平時不對外公開的製作工序，並體驗加飾與入窯。
      以三田當地食材與茶為主題的特別料理，以及正統茶道體驗。

      ■行程（Itinerary）

      10:00–11:30｜陶藝體驗
      在三田陶藝之森，由伊藤館長（Zuihou Ito）指導，體驗三田青瓷陶藝。
      並包含參觀平時不對外公開的製作工序。

      12:00–13:30｜日式午餐
      使用當地食材、以茶為主題的時令日式套餐。
      以三田青瓷器皿盛裝呈現。
      ※如遇無法準備的情況，將為您安排同等內容的餐飲體驗。

      14:00–16:00｜茶道體驗
      使用三田青瓷茶具的正統裏千家茶道體驗。
      ※視會場情況，可能在三田陶藝之森內的私人茶室舉行。

      ■本體驗包含的內容

      ・配備專屬導遊的私人一日遊
      ・三田青瓷陶藝工作坊
      ・平時不對外公開的製作工序的特別參觀
      ・以茶為主題的日式午餐套餐
      ・由裏千家主持的茶道體驗
      ・三田青瓷茶具套組（紀念品）
      ・所製作作品的宅配到府服務
      （完成後約1～2個月送達）

      推薦給重視文化深度、隱私考量，以及從容不迫行程安排的、追求特別體驗的貴賓。
      如對本行程有興趣，請透過連結查看詳情。
    `,
    },
    image:
      'https://lxnkiipxzsdpwledlbkp.supabase.co/storage/v1/object/public/experience-images/9a3775b5-5d19-4c03-85ec-4da3bd00c03d/e9b23f71-57cc-4d09-b023-1f0debc9a524.png',
    links: [
      {
        text: {
          ja: '三田陶芸の森 特別日帰りツアーページ',
          en: 'Sanda Ceramic Forest Special Day Tour page',
          'zh-CN': '三田陶艺之森 特别一日游页面',
          'zh-TW': '三田陶藝之森 特別一日遊頁面',
        },
        url: 'https://jtc-net.co.jp/sanda-tougei-no-mori-tour2025',
      },
    ],
  },
  {
    id: 3,
    date: '2025-12-01',
    category: {
      ja: 'お知らせ',
      en: 'News',
      'zh-CN': '通知',
      'zh-TW': '通知',
    },
    title: {
      ja: '合併に関するご案内',
      en: 'Notice Regarding Our Merger',
      'zh-CN': '关于公司合并的通知',
      'zh-TW': '關於公司合併的通知',
    },
    content: {
      ja: `
      このたび株式会社J・T・Cは、令和7年12月1日をもちまして株式会社カオスゲートと合併しました。株式会社カオスゲートを存続会社として新たに発足いたしました。
なお、存続会社である株式会社カオスゲートは、同日付で「株式会社J・T・C」へ商号を変更いたしました。
これにより、従来の株式会社J・T・Cの業務は新「株式会社J・T・C」が継承し、これまで同様、皆様のご期待に沿えるよう一層の努力を重ねてまいります。
また、旧株式会社J・T・Cの本社は、新会社の営業所として存続いたしますので、所在地および電話番号の変更はございません。決済業務等につきましても従前どおりお取り扱いいただけます。
今後とも倍旧のご支援とご厚誼を賜りますようお願い申し上げます。

    `,
      en: `
      On December 1, 2025, J.T.C Co., Ltd. merged with Chaos Gate Co., Ltd. The merged company started anew with Chaos Gate Co., Ltd. as the surviving company.
On the same date, the surviving company, Chaos Gate Co., Ltd., changed its trade name to "J.T.C Co., Ltd."
As a result, the operations of the former J.T.C Co., Ltd. have been taken over by the new J.T.C Co., Ltd., and we will continue to do our utmost to meet your expectations as before.
The head office of the former J.T.C Co., Ltd. will continue as an office of the new company, so there is no change to our address or telephone number. Settlement and other transactions can be handled exactly as before.
We ask for your continued support and goodwill.

    `,
      'zh-CN': `
      本公司株式会社J・T・C已于2025年12月1日与株式会社カオスゲート合并，并以株式会社カオスゲート为存续公司重新起步。
另外，存续公司株式会社カオスゲート已于同日将商号变更为「株式会社J・T・C」。
因此，原株式会社J・T・C的各项业务将由新的「株式会社J・T・C」承继，今后我们仍将一如既往，努力回应各位的期待。
此外，原株式会社J・T・C的总公司将作为新公司的营业所继续运营，所在地及电话号码均不变。结算等业务也可照旧办理。
今后也恳请各位一如既往地给予支持与关照。

    `,
      'zh-TW': `
      本公司株式会社J・T・C已於2025年12月1日與株式会社カオスゲート合併，並以株式会社カオスゲート為存續公司重新起步。
另外，存續公司株式会社カオスゲート已於同日將商號變更為「株式会社J・T・C」。
因此，原株式会社J・T・C的各項業務將由新的「株式会社J・T・C」承繼，今後我們仍將一如既往，努力回應各位的期待。
此外，原株式会社J・T・C的總公司將作為新公司的營業所繼續營運，所在地及電話號碼均不變。結算等業務也可照舊辦理。
今後也懇請各位一如既往地給予支持與關照。

    `,
    },
  },
  {
    id: 4,
    date: '2025-12-17',
    category: {
      ja: 'お知らせ',
      en: 'News',
      'zh-CN': '通知',
      'zh-TW': '通知',
    },
    title: {
      ja: '年末年始休業のお知らせ',
      en: 'Year-End and New Year Holiday Notice',
      'zh-CN': '年末年初休假通知',
      'zh-TW': '年末年初休假通知',
    },
    content: {
      ja: `
      平素は格別のご高配を賜り、厚く御礼申し上げます。
      誠に勝手ながら、弊社では下記の期間を年末年始休業とさせていただきます。
      お客様のご理解とご協力をお願い申し上げます。 
      
      休業期間：2025年12月27日（土）〜2026年1月4日（日）
      なお、休業期間中にいただきましたお問い合わせにつきましては、2026年1月5日（月）以降、順次対応させていただきます。
      何卒よろしくお願い申し上げます。

      ※2025年12月26日（金）は時短営業いたします。ご連絡ご希望の方は午前中までにお願いいたします。
      ※休業期間中の緊急のご連絡は、担当者の携帯電話までお願いいたします。
    `,
      en: `
      Thank you very much for your continued patronage.
      Please note that our offices will be closed for the year-end and New Year holidays during the period below.
      We appreciate your understanding and cooperation.

      Closed: Saturday, December 27, 2025 - Sunday, January 4, 2026
      Inquiries received during the closure will be answered in order from Monday, January 5, 2026 onward.
      Thank you for your understanding.

      *We will operate on shortened hours on Friday, December 26, 2025. If you need to reach us, please contact us before noon.
      *For urgent matters during the closure, please call the mobile phone of your usual contact person.
    `,
      'zh-CN': `
      承蒙各位一直以来的关照，谨致谢忱。
      本公司将于下列期间进行年末年初休假。
      敬请各位理解与配合。

      休假期间：2025年12月27日（周六）～2026年1月4日（周日）
      休假期间收到的咨询，将自2026年1月5日（周一）起依序回复。
      敬请见谅。

      ※2025年12月26日（周五）为缩短营业时间。如需联系，请于上午之前与我们联络。
      ※休假期间如有紧急事宜，请直接拨打负责人的手机。
    `,
      'zh-TW': `
      承蒙各位一直以來的關照，謹致謝忱。
      本公司將於下列期間進行年末年初休假。
      敬請各位理解與配合。

      休假期間：2025年12月27日（週六）～2026年1月4日（週日）
      休假期間收到的諮詢，將自2026年1月5日（週一）起依序回覆。
      敬請見諒。

      ※2025年12月26日（週五）為縮短營業時間。如需聯絡，請於上午之前與我們聯繫。
      ※休假期間如有緊急事宜，請直接撥打負責人的手機。
    `,
    },
  },
  {
    id: 5,
    date: '2026-07-16',
    category: {
      ja: 'お知らせ',
      en: 'News',
      'zh-CN': '通知',
      'zh-TW': '通知',
    },
    title: {
      ja: '多言語GPS音声ガイド「AYUBITO」サイト公開のお知らせ',
      en: 'Launch of the AYUBITO Multilingual GPS Audio Guide Website',
      'zh-CN': '多语言GPS语音导览「AYUBITO」网站上线通知',
      'zh-TW': '多語言GPS語音導覽「AYUBITO」網站上線通知',
    },
    content: {
      ja: `
      このたび、訪日インバウンド向けの多言語GPS音声ガイド「AYUBITO（アユビト）」の紹介サイトを公開いたしました。

      AYUBITOは、観光施設・ホテル・自治体・旅行会社向けの多言語GPS音声ガイドです。
      日本語原稿からAIが多言語翻訳・音声生成・QRコード発行を行い、アプリ不要のガイド体験を簡単に提供できます。

      ・多言語対応（AI翻訳・音声生成）
      ・QRコード1つで簡単利用（アプリ不要）
      ・GPS連動で位置情報に合わせて自動再生

      ※2026年秋リリース予定です。詳しくは公式サイトをご覧ください。
    `,
      en: `
      We have launched the website for AYUBITO, a multilingual GPS audio guide for inbound travel to Japan.

      AYUBITO is a multilingual GPS audio guide for tourist facilities, hotels, local governments and travel agencies.
      AI handles multilingual translation, voice generation and QR code issuance from your Japanese script, making it easy to offer a guide experience with no app required.

      - Multilingual support (AI translation and voice generation)
      - Simple access from a single QR code (no app required)
      - GPS-linked automatic playback based on the visitor's location

      *Release is scheduled for autumn 2026. Please see the official site for details.
    `,
      'zh-CN': `
      本公司已推出面向访日入境旅客的多语言GPS语音导览「AYUBITO」介绍网站。

      AYUBITO是面向旅游设施、酒店、地方政府与旅行社的多语言GPS语音导览。
      由AI从日文原稿完成多语言翻译、语音生成与二维码发行，无需安装应用即可轻松提供导览体验。

      ・多语言支持（AI翻译・语音生成）
      ・一个二维码即可轻松使用（无需应用）
      ・与GPS联动，依位置信息自动播放

      ※预计2026年秋季发布。详情请浏览官方网站。
    `,
      'zh-TW': `
      本公司已推出面向訪日入境旅客的多語言GPS語音導覽「AYUBITO」介紹網站。

      AYUBITO是面向觀光設施、飯店、地方政府與旅行社的多語言GPS語音導覽。
      由AI從日文原稿完成多語言翻譯、語音生成與QR Code發行，無需安裝應用程式即可輕鬆提供導覽體驗。

      ・多語言支援（AI翻譯・語音生成）
      ・一組QR Code即可輕鬆使用（免安裝應用程式）
      ・與GPS連動，依位置資訊自動播放

      ※預計2026年秋季推出。詳情請瀏覽官方網站。
    `,
    },
    links: [
      {
        text: {
          ja: 'AYUBITO 公式サイト',
          en: 'AYUBITO Official Site',
          'zh-CN': 'AYUBITO 官方网站',
          'zh-TW': 'AYUBITO 官方網站',
        },
        url: 'https://web.ayubito.com',
      },
    ],
  },
];
